<template>
    <div class="not-found-layout">
        <j-svg-icon name="404" class="not-found-img" />
        <span class="not-found-desc">
            {{name}} 页面未找到，请检查菜单地址,或联系管理员
        </span>
    </div>
</template>

<script>
    export default {
        name: "NotFound",
        data() {
            return {
                name: 'NotFound'
            }
        }
    }
</script>

<style lang="scss">
    .not-found-layout {
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .not-found-img {
            font-size: 300px;
        }
        .not-found-desc {
            padding-top: 5px;
            font-size: 14px;
            color: #909399;
        }
    }
</style>
